module.exports = __webpack_public_path__ + "media/images/logo-1d2a72b4.png";